import { render, staticRenderFns } from "./formBaseInspections.vue?vue&type=template&id=6f4c89c1&"
import script from "./formBaseInspections.vue?vue&type=script&lang=js&"
export * from "./formBaseInspections.vue?vue&type=script&lang=js&"
import style0 from "./formBaseInspections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports